import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import jwt from 'jsonwebtoken';

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      navigate('/login', { state: { from: location.pathname }, replace: true });
      return;
    }

    const decodedToken = jwt.decode(token);
    if (!decodedToken || decodedToken.exp * 1000 < Date.now()) {
      localStorage.removeItem('token'); // Limpiar el token expirado
      navigate('/login', { state: { from: location.pathname }, replace: true });
    }
  }, [navigate, location, searchParams]);

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
